module.exports = __webpack_public_path__ + "img/logo-date_pre.e7aa4707.svg";